/**
 * VDB Global Scripts
 * Extracted from layout/theme.liquid to improve FCP, TTI, and parse times.
 */

// 0. Capture ad click IDs & UTM and persist
(function () {
  var qs = new URLSearchParams(window.location.search);
  var keys = ['gclid','gbraid','wbraid','dclid','msclkid','fbclid','ttclid',
              'utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  var changed = false;

  function setCookie(n, v, days){
    var d = new Date(); d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = n + '=' + encodeURIComponent(v) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  keys.forEach(function(k){
    var val = qs.get(k);
    if (val) {
      localStorage.setItem('shopify_' + k, val);
      setCookie('shopify_' + k, val, 90);
      changed = true;
    }
  });
})();

// 1. Attach gclid to Shopify cart attributes
// Optimization: We could run this only on cart:added, but leaving on DOMContentLoaded for parity.
document.addEventListener('DOMContentLoaded', function() {
  var gclid = localStorage.getItem('shopify_gclid');
  if (gclid) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { gclid: gclid } })
        });
      });
  }
});

// 2. Cart Hold Timer — Engine (global)
// Session-only persistence (sessionStorage). Auto-restarts with welcome toast on return.
(function(){
  if (window.CartHoldTimer) return;

  // --- Storage: sessionStorage only (resets on browser close) ---
  function ssGet(k){ try{ return sessionStorage.getItem(k) }catch(e){ return null } }
  function ssSet(k,v){ try{ sessionStorage.setItem(k,v) }catch(e){} }
  function ssDel(k){ try{ sessionStorage.removeItem(k) }catch(e){} }

  var K_END = 'ct_end';
  var K_RST = 'ct_rst';
  var DUR_MS = 25*60*1000;           // 25 minutes
  var EXT_MS = 5*60*1000;            // 5 minutes

  function now(){ return Date.now(); }
  function setEnd(ms){ var ts=now()+ms; ssSet(K_END, String(ts)); return ts; }
  function getEnd(){ var v=parseInt(ssGet(K_END)||'0',10); return isNaN(v)?0:v; }

  window.CartHoldTimer = {
    get end(){ return getEnd(); },
    start: function(){
      var wasExpired = getEnd() > 0 && getEnd() <= now();
      var isNew = !getEnd();
      if (isNew || wasExpired) {
        setEnd(DUR_MS);
        if (wasExpired) dispatch('cart_timer_restarted');
      }
      dispatch('cart_timer_started');
    },
    resetFull: function(){ setEnd(DUR_MS); dispatch('cart_timer_reset'); },
    extend: function(ms){ var e=Math.max(getEnd(), now()+ms); ssSet(K_END, String(e)); dispatch('cart_timer_extended'); },
    expire: function(){ ssSet(K_END, String(now())); dispatch('cart_timer_expired'); },
    markRestartUsed: function(){ ssSet(K_RST,'1'); },
    restartUsed: function(){ return ssGet(K_RST)==='1'; },
    clear: function(){ ssDel(K_END); ssDel(K_RST); dispatch('cart_timer_cleared'); },
    DUR_MS: DUR_MS, EXT_MS: EXT_MS
  };

  function dispatch(name, detail){ try{ window.dispatchEvent(new CustomEvent(name,{detail})) }catch(_){} }

  // --- UI helpers ---
  function toggleTimerUI(show) {
    var el = document.getElementById('cart-timer');
    if (el) el.style.display = show ? '' : 'none';
  }

  function showWelcomeToast() {
    if (document.getElementById('ct-welcome-toast')) return;
    var isIT = (document.documentElement.lang || '').toLowerCase().startsWith('it')
      || /^it/.test((navigator.language || '').toLowerCase());
    var msg = isIT
      ? 'Bentornato! Abbiamo riservato di nuovo i tuoi vini \ud83c\udf77'
      : 'Welcome back! We\u2019ve reserved your wines again \ud83c\udf77';
    var toast = document.createElement('div');
    toast.id = 'ct-welcome-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = msg;
    toast.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:9999;'
      + 'background:#1a7a2e;color:#fff;padding:12px 24px;border-radius:10px;font-family:Newsreader,Georgia,serif;'
      + 'font-size:15px;font-weight:600;letter-spacing:.01em;box-shadow:0 4px 20px rgba(0,0,0,.15);'
      + 'opacity:0;transition:opacity .4s ease,transform .4s ease;transform:translateX(-50%) translateY(-8px);';
    document.body.appendChild(toast);
    requestAnimationFrame(function(){
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function(){
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(-8px)';
      setTimeout(function(){ toast.remove(); }, 400);
    }, 3500);
  }

  // Listen for auto-restart event to show toast
  window.addEventListener('cart_timer_restarted', showWelcomeToast);

  // --- Cart check: only start timer when cart has items ---
  function checkCartAndStart() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(data){
      if (data.item_count > 0) {
        window.CartHoldTimer.start();
        toggleTimerUI(true);
      } else {
        window.CartHoldTimer.clear();
        toggleTimerUI(false);
      }
    }).catch(function(){});
  }

  // Check on cart page load
  if (/\/cart/.test(window.location.pathname)) {
    checkCartAndStart();
  }

  // --- Intercept fetch/XHR for add-to-cart and cart changes ---
  (function(){
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input==='string')? input : (input&&input.url)||'';
      var isAdd = /\/cart\/add(?:\.js)?/.test(url || '');
      var isChange = /\/cart\/(?:change|update|clear)(?:\.js)?/.test(url || '');
      return _fetch.apply(this, arguments).then(function(res){
        if(isAdd && res && res.ok){ window.CartHoldTimer.resetFull(); toggleTimerUI(true); }
        if(isChange && res && res.ok){
          res.clone().json().then(function(data){
            if(data.item_count === 0){ window.CartHoldTimer.clear(); toggleTimerUI(false); }
          }).catch(function(){});
        }
        return res;
      });
    };
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m,u){ this.__isAdd = /\/cart\/add(?:\.js)?/.test(u||''); this.__isChange = /\/cart\/(?:change|update|clear)(?:\.js)?/.test(u||''); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){
      var xhr = this;
      this.addEventListener('load', function(){
        if(xhr.__isAdd && xhr.status>=200 && xhr.status<300){ window.CartHoldTimer.resetFull(); toggleTimerUI(true); }
        if(xhr.__isChange && xhr.status>=200 && xhr.status<300){
          try{ var data=JSON.parse(xhr.responseText); if(data.item_count===0){ window.CartHoldTimer.clear(); toggleTimerUI(false); } }catch(e){}
        }
      });
      return send.apply(this, arguments);
    };
  })();

  document.addEventListener('cart:updated', function(e){
    var n = e?.detail?.item_count;
    if(n===0){ window.CartHoldTimer.clear(); toggleTimerUI(false); }
    else { toggleTimerUI(true); }
  });
})();

// 3. Cart Sidebar Auto Close — single observer with interaction awareness
document.addEventListener("DOMContentLoaded", function() {
  const cartSidebar = document.querySelector('#site-cart-sidebar');
  if (!cartSidebar) return;

  let autoCloseTimer = null;
  const autoCloseDelay = 3000;

  function closeCart() {
    const closeButton = cartSidebar.querySelector('[data-js-close]');
    if (closeButton) {
      closeButton.click();
    } else {
      cartSidebar.classList.remove('sidebar--opened');
    }
    autoCloseTimer = null;
  }

  function startAutoCloseTimer() {
    clearAutoCloseTimer();
    autoCloseTimer = setTimeout(closeCart, autoCloseDelay);
  }

  function clearAutoCloseTimer() {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }

  // Watch for sidebar open/close via class changes
  new MutationObserver(function() {
    if (cartSidebar.classList.contains('sidebar--opened')) {
      startAutoCloseTimer();
    } else {
      clearAutoCloseTimer();
    }
  }).observe(cartSidebar, { attributes: true, attributeFilter: ['class'] });

  // Pause timer while user interacts
  ['mouseenter', 'touchstart', 'focusin'].forEach(function(event) {
    cartSidebar.addEventListener(event, clearAutoCloseTimer);
  });

  // Resume timer when user stops interacting
  ['mouseleave', 'touchend', 'focusout'].forEach(function(event) {
    cartSidebar.addEventListener(event, function() {
      if (cartSidebar.classList.contains('sidebar--opened')) {
        startAutoCloseTimer();
      }
    });
  });
});

// 5. Product Description Toggle Logic
document.addEventListener('DOMContentLoaded', function () {
  var desc = document.getElementById('product-description');
  if (!desc) return;

  var toggleBtn = document.getElementById('toggle-description');
  var hasHeadings = desc.querySelector('h2, h3');
  var isIT = document.documentElement.lang === 'it' || (window.Shopify && window.Shopify.locale === 'it');
  var TRUNCATED_HEIGHT = 220;
  var chevron = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 6 8 10 12 6"/></svg>';

  // --- Detect & extract wine specs (Denominazione: ...) into a styled card ---
  function buildSpecsCard() {
    var paragraphs = desc.querySelectorAll('p');
    var specsPara = null;
    var specsHeading = null;
    for (var i = 0; i < paragraphs.length; i++) {
      var text = paragraphs[i].textContent || '';
      if (/denominazion|denomination/i.test(text) && text.indexOf(':') !== -1) {
        specsPara = paragraphs[i];
        // Check if the previous sibling is an h2/h3 heading for this section
        var prev = specsPara.previousElementSibling;
        if (prev && /^H[23]$/.test(prev.tagName)) specsHeading = prev;
        break;
      }
    }
    if (!specsPara) return;

    // Parse "Key: Value" lines from br-separated content
    var html = specsPara.innerHTML;
    var lines = html.split(/<br\s*\/?>/i).map(function(l){ return l.replace(/<[^>]*>/g,'').trim(); }).filter(Boolean);
    var pairs = [];
    lines.forEach(function(line) {
      var idx = line.indexOf(':');
      if (idx > 0) pairs.push({ key: line.substring(0, idx).trim(), val: line.substring(idx + 1).trim() });
    });
    if (pairs.length < 2) return;

    // Build the card
    var card = document.createElement('div');
    card.className = 'vdb-specs-card';
    var title = isIT ? 'Scheda Tecnica' : 'Wine Specs';
    var specsIcon = '<svg class="vdb-specs-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 2h4.5l3 3v9h-7.5z"/><path d="M9 2v3h3"/><path d="M6.5 8h3"/><path d="M6.5 10.5h3"/></svg>';
    var cardHTML = '<div class="vdb-specs-card__header">' + specsIcon + title + '</div><dl class="vdb-specs-card__list">';
    pairs.forEach(function(p) {
      cardHTML += '<div class="vdb-specs-card__row"><dt>' + p.key + '</dt><dd>' + p.val + '</dd></div>';
    });
    cardHTML += '</dl>';
    card.innerHTML = cardHTML;

    // Remove original paragraph and its heading from the description
    if (specsHeading) specsHeading.remove();
    specsPara.remove();

    // Insert at top of description
    desc.insertBefore(card, desc.firstChild);
  }

  buildSpecsCard();

  if (!hasHeadings) {
    // --- Path A: No headings → inject title, truncate + show more ---
    var productTitle = (document.querySelector('h1.product__title') || {}).textContent || '';
    productTitle = productTitle.trim();
    var label = isIT ? 'Descrizione del prodotto' : 'Description of';
    var descIcon = '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 2h6v3c0 2.2-1.3 3.5-3 3.5S5 7.2 5 5V2z"/><path d="M8 8.5v4"/><path d="M5.5 12.5h5"/></svg>';
    var h2 = document.createElement('h2');
    h2.className = 'injected-heading';
    h2.innerHTML = descIcon + ' ' + label + ' ' + productTitle.replace(/</g, '&lt;');
    // Insert after specs card if present, else at start
    var specsCard = desc.querySelector('.vdb-specs-card');
    if (specsCard) { specsCard.after(h2); } else { desc.prepend(h2); }

    // Measure content
    desc.style.maxHeight = 'none';
    desc.classList.remove('description-truncated');
    var fullHeight = desc.scrollHeight;
    var mqDesk = window.matchMedia('(min-width: 768px)');

    function applyTruncation() {
      if (mqDesk.matches) {
        // Desktop: always fully open, no truncation
        desc.classList.remove('description-truncated');
        desc.classList.add('expanded');
        desc.style.maxHeight = 'none';
        if (toggleBtn) toggleBtn.style.display = 'none';
      } else {
        // Mobile: truncate if tall enough
        if (fullHeight > TRUNCATED_HEIGHT + 80) {
          var isExpanded = desc.classList.contains('expanded');
          if (!isExpanded) {
            desc.style.maxHeight = TRUNCATED_HEIGHT + 'px';
            desc.classList.add('description-truncated');
          }
          if (toggleBtn) {
            toggleBtn.style.display = 'inline-flex';
            toggleBtn.innerHTML = (isExpanded ? (isIT ? 'Mostra meno ' : 'Show Less ') : (isIT ? 'Mostra di più ' : 'Show More ')) + chevron;
            toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          }
        } else {
          desc.classList.remove('description-truncated');
          desc.style.maxHeight = 'none';
          if (toggleBtn) toggleBtn.style.display = 'none';
        }
      }
    }

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-controls', 'product-description');
      toggleBtn.addEventListener('click', function () {
        var expanded = desc.classList.toggle('expanded');
        toggleBtn.classList.toggle('expanded', expanded);
        desc.style.maxHeight = expanded ? fullHeight + 40 + 'px' : TRUNCATED_HEIGHT + 'px';
        if (expanded) desc.classList.remove('description-truncated');
        else desc.classList.add('description-truncated');
        toggleBtn.innerHTML = (expanded ? (isIT ? 'Mostra meno ' : 'Show Less ') : (isIT ? 'Mostra di più ' : 'Show More ')) + chevron;
        toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    applyTruncation();
    mqDesk.addEventListener('change', applyTruncation);

  } else {
    // --- Path B: Has headings → responsive accordion ---
    // Desktop: all sections open, individual toggle. Mobile: single-open, first open.
    if (toggleBtn) toggleBtn.style.display = 'none';
    desc.classList.remove('description-truncated');
    desc.style.maxHeight = 'none';

    var headings = desc.querySelectorAll('h2, h3');
    var allSections = [];
    var mqDesk = window.matchMedia('(min-width: 768px)');

    // Wine-themed SVG icons for accordion headings
    var accIcons = {
      wine: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 2h6v3c0 2.2-1.3 3.5-3 3.5S5 7.2 5 5V2z"/><path d="M8 8.5v4"/><path d="M5.5 12.5h5"/></svg>',
      grape: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><circle cx="6.5" cy="7" r="1.7"/><circle cx="9.5" cy="7" r="1.7"/><circle cx="8" cy="10" r="1.7"/><path d="M8 2v3"/><path d="M6.5 3l1.5-1 1.5 1"/></svg>',
      food: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M4 2v3.5c0 1 1 1.5 1.5 1.5V14"/><path d="M4 4h3"/><path d="M11 2c1.5 1 2 3 2 4.5 0 .8-.5 1.2-1 1.2V14"/></svg>',
      leaf: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M3 13C3 7 7 3 13 3c0 6-4 10-10 10z"/><path d="M3 13C6.5 9.5 10 6 13 3"/></svg>',
      star: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2l1.8 3.6 4 .6-2.9 2.8.7 4L8 11.1 4.4 13l.7-4L2.2 6.2l4-.6z"/></svg>',
      barrel: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="8" cy="3" rx="3.5" ry="1.5"/><ellipse cx="8" cy="13" rx="3.5" ry="1.5"/><path d="M4.5 3v10"/><path d="M11.5 3v10"/><path d="M4 8h8"/></svg>',
      info: '<svg class="vdb-acc-icon" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"/><path d="M8 11v-3.5"/><circle cx="8" cy="5.5" r=".7" fill="currentColor" stroke="none"/></svg>'
    };
    function matchIcon(text) {
      text = text || '';
      if (/degustazion|tasting|note|assaggio|profum|aroma|colore|caratter|profilo|sapor|gusto|flavor/i.test(text)) return accIcons.wine;
      if (/vitigno|grape|uva|uve|vendemmia|vineyard|coltivaz/i.test(text)) return accIcons.grape;
      if (/abbinam|pairing|food|cucina|gastr|serv|ricett/i.test(text)) return accIcons.food;
      if (/terroir|territor|region|zona|origin|suolo|clima|altitud/i.test(text)) return accIcons.leaf;
      if (/vinificaz|affinam|invecchiam|metodo|ferment|barrique|botte/i.test(text)) return accIcons.barrel;
      if (/premi|award|riconosc|medal|punteggi|score|rating|guide|concors|james|parker|gambero/i.test(text)) return accIcons.star;
      if (/conserv|storage|temperatura|temp|cellar/i.test(text)) return accIcons.barrel;
      // Wine denominations (DOCG, DOC, IGT, IGP, specific names)
      if (/\bDOCG\b|\bDOC\b|\bIGT\b|\bIGP\b|brunello|barolo|chianti|amarone|prosecco|montepulciano|lambrusco|vermentino|primitivo/i.test(text)) return accIcons.wine;
      // Producers / wineries
      if (/fattoria|azienda|cantina|tenuta|castello|podere|masseria|cascina|casa vinicola|winery|estate/i.test(text)) return accIcons.leaf;
      // Generic description / about
      if (/descri|storia|history|about|info/i.test(text)) return accIcons.wine;
      return accIcons.wine;
    }

    headings.forEach(function (heading, i) {
      var wrap = document.createElement('div');
      wrap.className = 'vdb-accordion__content';
      wrap.id = 'vdb-acc-' + i;

      var sib = heading.nextElementSibling;
      while (sib && !/^H[23]$/.test(sib.tagName)) {
        var next = sib.nextElementSibling;
        wrap.appendChild(sib);
        sib = next;
      }

      heading.after(wrap);
      heading.className = 'vdb-accordion__heading';
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-controls', 'vdb-acc-' + i);

      // Inject wine-themed icon based on heading text
      heading.insertAdjacentHTML('afterbegin', matchIcon(heading.textContent));

      allSections.push({ heading: heading, content: wrap });

      function toggle() {
        var isOpen = wrap.classList.contains('expanded');
        if (mqDesk.matches) {
          // Desktop: individual toggle (open/close freely)
          if (isOpen) {
            wrap.classList.remove('vdb-flow'); // restore overflow:hidden before collapse
            wrap.classList.remove('expanded');
            heading.classList.remove('expanded');
            heading.setAttribute('aria-expanded', 'false');
            wrap.style.maxHeight = '0';
          } else {
            wrap.classList.add('expanded');
            heading.classList.add('expanded');
            heading.setAttribute('aria-expanded', 'true');
            wrap.style.maxHeight = wrap.scrollHeight + 'px';
            // After transition, enable float wrapping
            setTimeout(function(){ if (wrap.classList.contains('expanded')) wrap.classList.add('vdb-flow'); }, 420);
          }
        } else {
          // Mobile: single-open (can't close active)
          if (isOpen) return;
          allSections.forEach(function (s) {
            s.content.classList.remove('expanded');
            s.heading.classList.remove('expanded');
            s.heading.setAttribute('aria-expanded', 'false');
            s.content.style.maxHeight = '0';
          });
          wrap.classList.add('expanded');
          heading.classList.add('expanded');
          heading.setAttribute('aria-expanded', 'true');
          wrap.style.maxHeight = wrap.scrollHeight + 'px';
        }
      }

      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    // Open sections based on viewport
    function openForViewport() {
      allSections.forEach(function (s, idx) {
        if (mqDesk.matches || idx === 0) {
          s.content.classList.add('expanded');
          s.heading.classList.add('expanded');
          s.heading.setAttribute('aria-expanded', 'true');
          requestAnimationFrame(function () {
            s.content.style.maxHeight = s.content.scrollHeight + 'px';
            // Desktop: enable float wrapping after height settles
            if (mqDesk.matches) {
              setTimeout(function(){ s.content.classList.add('vdb-flow'); }, 60);
            }
          });
        } else {
          s.content.classList.remove('expanded');
          s.content.classList.remove('vdb-flow');
          s.heading.classList.remove('expanded');
          s.heading.setAttribute('aria-expanded', 'false');
          s.content.style.maxHeight = '0';
        }
      });
    }
    openForViewport();
    mqDesk.addEventListener('change', openForViewport);
  }
});

// 6. Variant Label Icons (Annata → calendar, etc.)
document.addEventListener('DOMContentLoaded', function () {
  var variantIcons = {
    annata: '<svg style="width:14px;height:14px;vertical-align:-2px;opacity:0.45;margin-right:2px" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="12" height="11" rx="1.5"/><path d="M2 6.5h12"/><path d="M5.5 1.5v3"/><path d="M10.5 1.5v3"/></svg>',
    formato: '<svg style="width:14px;height:14px;vertical-align:-2px;opacity:0.45;margin-right:2px" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2c-1.5 0-2.5 1-2.5 3v6c0 1.5.8 2.5 2.5 2.5h4c1.5 0 2.5-1 2.5-2.5V5c0-2-1-3-2.5-3H6z"/><path d="M6.5 5h3"/></svg>'
  };
  document.querySelectorAll('.product-variant__name').forEach(function (el) {
    var text = (el.textContent || '').trim().toLowerCase();
    var icon = null;
    if (/annat|vintage|year/i.test(text)) icon = variantIcons.annata;
    else if (/formato|size|bottle/i.test(text)) icon = variantIcons.formato;
    if (icon) el.insertAdjacentHTML('afterbegin', icon);
  });
});

// 7. Cart Spedizioni Icons
document.addEventListener('DOMContentLoaded', function () {
  if (!/\/cart/i.test(window.location.pathname)) return;
  var iconStyle = 'width:32px;height:32px;color:#9a000b;opacity:0.75';
  var spedIcons = {
    truck: '<svg style="' + iconStyle + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1.5"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    shield: '<svg style="' + iconStyle + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    leaf: '<svg style="' + iconStyle + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20c4 0 8.5-3 11-8"/><path d="M2 2s7.5 2 11.5 8"/><path d="M20.5 3.5C16 7 12 10.5 10 15"/></svg>'
  };
  function matchSpedIcon(text) {
    if (/veloc|spedi|consegn|corrier|rapid|fast|ship|deliver/i.test(text)) return spedIcons.truck;
    if (/sicur|imballo|antirottur|protez|safe|pack|shield/i.test(text)) return spedIcons.shield;
    if (/filiera|vigneto|produttor|bottiglia|origin|supply|vine/i.test(text)) return spedIcons.leaf;
    return spedIcons.truck;
  }
  // Find the Spedizioni section by its heading text
  var headings = [];
  document.querySelectorAll('.section-heading').forEach(function (sh) {
    if (/spedizion/i.test(sh.textContent)) {
      var container = sh.closest('[id^="shopify-section"]') || sh.closest('.container--large');
      if (container) headings = container.querySelectorAll('.js-slider-item .h5');
    }
  });
  headings.forEach(function (h) {
    var text = h.textContent || '';
    var icon = matchSpedIcon(text);
    var wrap = document.createElement('div');
    wrap.className = 'vdb-sped-icon-wrap';
    wrap.innerHTML = icon;
    var parent = h.closest('.spacing--large') || h.parentElement.parentElement;
    if (parent) parent.insertBefore(wrap, parent.firstChild);
  });
});

// 8. Clickable Badge Delegation
(function(){
  function go(e, el){ e.preventDefault(); e.stopImmediatePropagation(); window.location.href = el.dataset.url; }
  document.addEventListener('click', function(e){
    const el = e.target.closest('.clickable-badge');
    if (el) go(e, el);
  }, true);
  document.addEventListener('keydown', function(e){
    if((e.key==='Enter'||e.key===' ') && e.target.classList && e.target.classList.contains('clickable-badge')){
      go(e, e.target);
    }
  }, true);
})();

// 8. Debora Mini-Badge — relocate from description onto product image
// Uses MutationObserver to persist across Debora app re-renders
(function(){
  var target = null;
  var moved = false;

  function getTarget(){
    if (target && document.contains(target)) return target;
    target = document.querySelector('.product-media-badges--in-media')
          || document.querySelector('.product-gallery-item');
    return target;
  }

  function moveBadge(){
    var badge = document.querySelector('.debora-mini-badge');
    if (!badge) return false;
    var dest = getTarget();
    if (!dest) return false;
    if (dest.contains(badge)) return true;
    // Clone to survive if the original gets destroyed by app re-render
    var clone = badge.cloneNode(true);
    clone.style.cssText = 'position:absolute !important;bottom:8px !important;left:8px !important;top:auto !important;right:auto !important;z-index:10;';
    clone.setAttribute('data-vdb-moved', 'true');
    // Remove any previously moved clone
    var old = dest.querySelector('.debora-mini-badge[data-vdb-moved]');
    if (old) old.remove();
    dest.appendChild(clone);
    // Hide the original so it doesn't show in description
    badge.style.display = 'none';
    moved = true;
    return true;
  }

  function init(){
    // Poll for the badge (Debora app loads async)
    var attempts = 0;
    var poll = setInterval(function(){
      attempts++;
      if (moveBadge()) clearInterval(poll);
      if (attempts > 60) clearInterval(poll);
    }, 250);

    // Watch for Debora app re-renders that might re-create the badge
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(){
        var badge = document.querySelector('.debora-mini-badge:not([data-vdb-moved])');
        if (badge) {
          badge.style.display = 'none';
          // Refresh the clone if needed
          var dest = getTarget();
          if (dest && !dest.querySelector('.debora-mini-badge[data-vdb-moved]')) {
            moveBadge();
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Clean up after 30s — app should be done rendering
      setTimeout(function(){ observer.disconnect(); }, 30000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
